import { render, staticRenderFns } from "./UserInfoBlock.vue?vue&type=template&id=42e7636c&scoped=true"
import script from "./UserInfoBlock.vue?vue&type=script&lang=js"
export * from "./UserInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e7636c",
  null
  
)

export default component.exports